import { Component, OnInit } from '@angular/core';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router, ActivatedRoute } from "@angular/router";

import { MedicamentoService } from '../../services/medicamento.service';

@Component({
    selector: 'app-medicamentos',
    templateUrl: './medicamentos.component.html',
    styleUrls: ['./medicamentos.component.css'],
    standalone: false
})
export class MedicamentosComponent implements OnInit {
  loading = false;
  isVisibleCancelFiltro = false;
  isVisibleDetalhe = false;
  //Variaveis de Pesquisas
  pesquisa = '';
  tipoPesquisa = 'descricao';
  constructor(
    private message: NzMessageService,
    private route: ActivatedRoute,
    private router: Router,
    private medicamentoService: MedicamentoService,
  ) { }

  //Table
  pageSize = 1;
  pageIndex = 1;
  total = 0;
  medicamentos = [];
  medicamentoModal = [];

   //Variaveis do modal de importação (Excel)
   visibleModalImportacao = false;
   visibleModalIndicadores = false;

   visibleModalPreviaHistoricoAlteracoes = false;
  ngOnInit(): void {
  }

  pesquisar(){
    this.loading = true;
    this.medicamentoService.all(this.pageIndex, this.tipoPesquisa, this.pesquisa).subscribe((m: any) => {
      this.pageIndex = 1;
      this.medicamentos = m.data.medicamento.data;
      this.total = m.data.medicamento.total;
      this.pageSize = m.data.medicamento.per_page;
      this.loading = false;
    });
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.loading = true;
    this.medicamentoService.all(params.pageIndex).subscribe((m: any) => {
      this.pageIndex = params.pageIndex;
      this.medicamentos = m.data.medicamento.data;
      this.total = m.data.medicamento.total;
      this.pageSize = m.data.medicamento.per_page;
      this.loading = false;
    });
  }

  recarregarMedicamentos(){
    this.medicamentoService.all(this.pageIndex).subscribe((m: any) => {
      this.medicamentos = m.data.medicamento.data;
      this.total = m.data.medicamento.total;
      this.pageSize = m.data.medicamento.per_page;
      this.loading = false;
    });
  }


  ativar(idmedicamento) {
    let idLoading = this.message.loading('Ativando medicamento...').messageId;
    this.medicamentoService.ativar(idmedicamento).subscribe((i: any) => {
      this.message.remove(idLoading);
      this.message.success('Ativação realizada com SUCESSO!');
      this.loading = true;
      this.medicamentoService.all(this.pageIndex).subscribe((m: any) => {
        this.medicamentos = m.data.medicamento.data;
        this.total = m.data.medicamento.total;
        this.pageSize = m.data.medicamento.per_page;
        this.loading = false;
      });
    });
  }

  inativar(idmedicamento) {
    let idLoading = this.message.loading('Inativando medicamento...').messageId;
    this.medicamentoService.inativar(idmedicamento).subscribe((i: any) => {
      this.message.remove(idLoading);
      this.message.success('Inativação realizada com SUCESSO!');
      this.loading = true;
      this.medicamentoService.all(this.pageIndex).subscribe((m: any) => {
        this.medicamentos = m.data.medicamento.data;
        this.total = m.data.medicamento.total;
        this.pageSize = m.data.medicamento.per_page;
        this.loading = false;
      });
    });
  }

  fecharModalImportacao(){
    this.visibleModalImportacao = false;
    this.recarregarMedicamentos();
  }

  mostrarModalImportacao(){
    this.visibleModalImportacao = true;
  }

  closeModalDetalhe(){
    this.isVisibleDetalhe = false;
  }

  openModalDetalhe(idmedicamento){
    this.medicamentoModal = this.medicamentos.filter(d => d.idmedicamento === idmedicamento);
    this.isVisibleDetalhe = true;
  }

  removerFiltro() {
    this.pesquisa = '';
    this.tipoPesquisa = 'nome';
    this.searchMedicamento();
    this.isVisibleCancelFiltro = false;
  }

  isNumeric(text: any){
    return !isNaN(parseFloat(text));
  }
  
  searchMedicamento() {
    if (this.pesquisa !== undefined) {
      this.isVisibleCancelFiltro = true;
      this.loading = true; 
 
      this.medicamentoService.all(this.pageIndex, this.tipoPesquisa, this.pesquisa).subscribe((m: any) => {
        this.pageIndex = 1;
        this.medicamentos = m.data.medicamento.data;
        this.total = m.data.medicamento.total;
        this.pageSize = m.data.medicamento.per_page;
        this.loading = false;
      });
    } else {
      this.message.warning("Digite a sua pesquisa para continuar.");
    }

  }

  formatarPrincipiosAtivos(arr: string[]): string {
    let principiosAtivos:string[] = arr.map((data: any) => {
      return data.nome;
    });
    if (principiosAtivos.length > 1) {
      const ultimoItem = principiosAtivos.pop();
      return principiosAtivos.join(', ') + ' e ' + ultimoItem;
    } else {
      return principiosAtivos.join(', ');
    }
  }

  fecharModalPreviaHistoricoAlteracoes(){
    this.visibleModalPreviaHistoricoAlteracoes = false;
  }

  abrirModalPreviaHistoricoAlteracoes(){
    this.visibleModalPreviaHistoricoAlteracoes = true;
  }
}
